import React, { useEffect, useState } from 'react'
import SearchBox from '../SearchBox/SearchBox'
import styles from './Resource.module.css'
import Button from '@material-ui/core/Button';
import ResourceItem from './ResourceItem/ResourceItem';
import { Link } from 'react-router-dom';
import { useStateValue } from '../../StateProvider';
import RequestItem from './Requests/RequestItem';

function Resource({type,nationWideSupplier}) {

    const [{allResourceData,allRequestData}, dispatch] = useStateValue()

    const [filterCity,setFilterCity] = useState('')
    const [filterState,setFilterState] = useState('')
    const [stateLink,setStateLink] = useState('')
    const [statewiseSupplierData,setStatewiseSupplierData]=useState([]);


    useEffect(()=>{
        getStateWiseSuppliersData()
      },[])

      const getStateWiseSuppliersData=()=>{
        fetch('StateWiseSuppliers.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then((response) => {
            return response.json();
          })
          .then((myJson) => {
            setStatewiseSupplierData(myJson.suppliers.map((supplier)=>(
                {
                    name:supplier.name,
                    link:supplier.link,
                    type:supplier.type,
                }
            )))
          })
      }

      useEffect(() => {
        dispatch({
            type: 'UPDATE_PAGE',
            page: type
        })
      }, [])


        useEffect(() => {
            setStateLink('')
            statewiseSupplierData.filter((state)=> state.name.toLowerCase().includes(filterState?.toLowerCase()) && (state.type.toLowerCase().includes(type.toLowerCase()))).map((state)=> setStateLink(state.link))
        }, [filterState])

        const updatePage = () =>{
            dispatch({
                type: 'UPDATE_PAGE',
                page: "home"
            })
        }

        


    return (
        <div className={styles.component}>
            <div className={styles.searchResults}>
                <h1>{type} Resources</h1>
                <SearchBox setFilterCity={setFilterCity} setFilterState={setFilterState}/>

                <a href={!stateLink ? '#' :stateLink} target={stateLink && '_blank'} rel="noreferrer" className={styles.buttonLink} >
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<i className='fas fa-truck-moving' />}
                    className={styles.addResources}
                    style={{marginTop:'15px'}}
                    disabled={!filterState | !stateLink}
                    >
                        Full list of suppliers in {filterState ? filterState : '(select state)'}
                    </Button> 
                </a>

                {
                    (allResourceData.length === 0) ? (
                        <div className={styles.emptyList}>
                        <div className={styles.emptyListInner}>
                            <h1>There are no resources availble here as of now. To get the list of State-wise Suppliers, please use the buttons above.</h1>
                            <h3>If you have any leads, Please add them here by clicking the button below and logging in.</h3><br/>
                            <Link to='/login' className={styles.buttonLink}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<i className='fas fa-plus' />}
                                    className={styles.logInToAdd}
                                >
                                    Add Resource Leads
                                </Button>
                            </Link>
                            </div>
                        </div>
                    ): null
                }

                {
                    
                    
                    allResourceData?.filter((data)=>data.type.toLowerCase().includes(type.toLowerCase())).map((data)=>{

                        if(data){
                        if((!filterState | filterState?.toLowerCase() === data.state.toLowerCase())){
                            if((!filterCity | filterCity?.toLowerCase() === data.city.toLowerCase())){
                                return (<ResourceItem orgName={data.orgName}
                                    key={data._id}
                                personnelName={data.personnelName}
                                address={data.address}
                                contactNumber={data.contactNumber}
                                state={data.state}
                                city={data.city}
                                units={data.units} 
                                type={data.type} 
                                resourceClass = {(data.type==='food')? data.foodType : (data.type==='Plasma') ? data.bloodType : null}
                                id={data._id}
                                updatedDate={data.updatedAt}/>
                                
                                
                                
                                )
                            }
                        }}else{
                            return (
                                <div className={styles.emptyList}>
                                <div className={styles.emptyListInner}>
                                    <h1>There are no resources availble here as of now. To get the list of State-wise Suppliers, please use the buttons above.</h1>
                                    <h3>If you have any leads, Please add them here by clicking the button below and logging in.</h3><br/>
                                    <Link to='/login' className={styles.buttonLink}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={<i className='fas fa-plus' />}
                                            className={styles.logInToAdd}
                                        >
                                            Add Resource Leads
                                        </Button>
                                    </Link>
                                    </div>
                                </div>
                            )
                        }
                    })
                }

                    
                
            </div>

            
            <div className={styles.currentRequests}>
                <h1>Emergency Requests</h1>
                <a href={nationWideSupplier} target="_blank" rel="noreferrer" className={styles.buttonLink}>
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<i className='fas fa-truck-moving' />}
                    className={styles.addResources}
                    disabled={!nationWideSupplier}
                    >
                        Get list of nationwide suppliers
                    </Button> 
                </a>
                <Link to={(true)?'/dashboard' :'/login'} className={styles.buttonLink}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<i className='fas fa-plus' />}
                        className={styles.addResources}
                        onClick={updatePage}
                    >
                        Add Requests
                    </Button> 
                </Link>

                <div>

                {
                    
                    
                    allRequestData?.filter((data)=>data.resourceType.toLowerCase().includes(type.toLowerCase())).map((data)=>{

                        if(data){
                        if((!filterState | filterState?.toLowerCase() === data.state.toLowerCase())){
                            if((!filterCity | filterCity?.toLowerCase() === data.district.toLowerCase())){
                                return (<RequestItem name={data.name}
                                    key={data._id}
                                    message={data.message}
                                    contact={data.contact}
                                    state={data.state}
                                    city={data.district}
                                    type={data.resourceType} 
                                    email={data.email}
                                    subType = {(data.type==='food')? data.foodType : (data.type==='Plasma') ? data.bloodType : null}
                                    id={data._id}
                                    updatedDate={data.updatedAt}/>
                                
                                )
                            }
                        }}else{
                            return (
                                <div className={styles.emptyList}>
                                <div className={styles.emptyListInner}>
                                    <h1>There are no are no requests currently.</h1>
                                        <h3>To make a request, please login using the button above.</h3><br/>
                                    
                                    </div>
                                </div>
                            )
                        }
                    })
                }
                </div>
            </div>
        </div>
    )
}

export default Resource
